/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { ShippingRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { ShippingResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * ShippingPriceApi - axios parameter creator
 * @export
 */
export const ShippingPriceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get Shipping Charge
         * @summary Get Shipping Charge
         * @param {string} storeId The store identifier.
         * @param {ShippingRequest} shippingRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipping: async (storeId: string, shippingRequest: ShippingRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('shipping', 'storeId', storeId)
            // verify required parameter 'shippingRequest' is not null or undefined
            assertParamExists('shipping', 'shippingRequest', shippingRequest)
            const localVarPath = `/store/{storeId}/shipping/priceDisplay`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shippingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShippingPriceApi - functional programming interface
 * @export
 */
export const ShippingPriceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShippingPriceApiAxiosParamCreator(configuration)
    return {
        /**
         * Get Shipping Charge
         * @summary Get Shipping Charge
         * @param {string} storeId The store identifier.
         * @param {ShippingRequest} shippingRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shipping(storeId: string, shippingRequest: ShippingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shipping(storeId, shippingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShippingPriceApi - factory interface
 * @export
 */
export const ShippingPriceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShippingPriceApiFp(configuration)
    return {
        /**
         * Get Shipping Charge
         * @summary Get Shipping Charge
         * @param {string} storeId The store identifier.
         * @param {ShippingRequest} shippingRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipping(storeId: string, shippingRequest: ShippingRequest, options?: any): AxiosPromise<ShippingResponse> {
            return localVarFp.shipping(storeId, shippingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShippingPriceApi - object-oriented interface
 * @export
 * @class ShippingPriceApi
 * @extends {BaseAPI}
 */
export class ShippingPriceApi extends BaseAPI {
    /**
     * Get Shipping Charge
     * @summary Get Shipping Charge
     * @param {string} storeId The store identifier.
     * @param {ShippingRequest} shippingRequest The request object for project creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingPriceApi
     */
    public shipping(storeId: string, shippingRequest: ShippingRequest, options?: any) {
        return ShippingPriceApiFp(this.configuration).shipping(storeId, shippingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
